import * as badge from './badge';
import * as point from './point';
import * as vote from './vote';
import * as user from './user';

export const mockDB = {
  badge,
  point,
  vote,
  user,
};
